import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { useMutation } from '@apollo/client/react'
// components
import PageLoader from 'components/UI/Loader/PageLoader'
// graphql
import { PROCESS_ACTIVE_DIRECTORY_CODE } from 'graphql/active-directory/mutations'
// types
import { IMutationResponse } from 'types/graphql'

const Callback: React.FC = () => {
  const router = useRouter()

  const [processCode] = useMutation<IMutationResponse, { code: string }>(PROCESS_ACTIVE_DIRECTORY_CODE)

  React.useEffect(() => {
    const code = router.query.code as string

    if (code) {
      processCode({ variables: { code } })
        .then(() => router.push('/settings/integrations'))
        .catch(() => router.push('/settings/integrations'))
    }
  }, [router.query.code])

  return <PageLoader isLoading />
}

export default Callback
